import React, { Fragment } from 'react';
import Navbar from '../../components/Navbar/Navbar';
import PageTitle from '../../components/pagetitle/PageTitle'
import Scrollbar from '../../components/scrollbar/scrollbar'
import { useParams } from 'react-router-dom'
import Events from '../../api/Events';
import sSimg from '../../images/resource/BrainsandBrews.jpg';
import Subscribe2 from '../../components/Subscribe2/Subscribe2';
import Footer2 from '../../components/footer2/Footer2';
import VenueSection2 from '../../components/VenueSection/VenueSection2';


const EventSinglePage = (props) => {
    const { slug } = useParams()

    const eventDetails = Events[3];

    return (
        <Fragment>
            <Navbar hclass={'wpo-header-style-5'} topbarClass={'tb-block'} />
            <PageTitle pageTitle={eventDetails.eTitle} pagesub={'Event Details'} pageTitle2={'Event Details'}/>
            <section className="event-detail">
                <div className="auto-container">
                    <div className="inner-container">
                        <div className="event-detail_image">
                            <img src={sSimg} alt="" />
                        </div>
                        <div className="upper-box d-flex justify-content-between flex-wrap">
                            <h2 className="event-detail_title">{eventDetails.eTitle}</h2>
                            {/* <div className="event-detail_author">
                                <div className="event-detail_author-image">
                                    <img src={eventDetails.eImg} alt="" />
                                </div>
                                <div className="event-detail_author-name">{eventDetails.speaker}, <span>Art Critic</span></div>
                                <div className="event-detail_author-location"><span>Location:</span> SHOTS, <br /> R G Baruah Road , Guwahati</div>
                                <div className="event-detail_author-timing">7PM Onwards</div>
                                <div className="event-detail_author-icon flaticon-voice"></div>
                            </div> */}
                        </div>
                        <p>Brains & Brews is a networking experience where fresh thinking meets casual conversations. It’s not about stiff introductions or forced exchanges, but about sharing ideas over coffee mugs and pint glasses. Here, creativity flows as easily as the brews, and every conversation can spark collaboration, opportunity, or just a new perspective. Brains & Brews isn’t just an event—it’s a community moment where minds connect, stories are exchanged, and ideas ferment into something bigger.</p>
                        <p>It is a curated networking format designed to foster authentic connections, professional collaborations, and community learning. Away from rigid structures, participants interact through casual dialogues, insightful discussions, and relaxed social settings that inspire openness. It’s where professionals pause the hustle, build genuine relationships, and walk away with ideas (and friends) worth remembering.</p>
                        <div className="middle-column">
                            <div className="row clearfix">
                                <div className="column col-lg-6 col-md-12 col-sm-12">
                                    <h3 className="event-detail_subtitle">Key Points of the Event</h3>
                                    <ul className="event-detail_list">
                                        <li>Share your expertise and discover fresh perspectives over an easygoing conversation.</li>
                                        <li>Engage in spontaneous discussions that break the ice and build real connections.</li>
                                        <li>Get spotlighted in community recaps and storytelling moments.</li>
                                        <li>Be part of a culture that values curiosity, collaboration, and fun learning.</li>
                                    </ul>
                                </div>
                                <div className="column col-lg-6 col-md-6 col-sm-12">
                                    <div className="event-detail_image-two">
                                        <img src="assets/images/resource/event-1.jpg" alt="" />
                                    </div>
                                </div>
                            </div>
                        </div>
                        <p>Brains & Brews is designed to help you relax, open up, and connect with others in an atmosphere that feels natural. Whether you come with an idea, a challenge, or just curiosity, you’ll find someone to share it with. No podiums, no scripts—just people, ideas, and the buzz of possibility.</p>
                         <div className="appointmeny_button-box" style={{ textAlign: 'center', margin: '30px 0' }}>
                            <button
                                type="button"
                                className="theme-btn btn-style-one"
                                disabled
                                aria-disabled="true"
                                style={{ cursor: 'not-allowed', opacity: 0.6 }}
                            >
                                <span className="btn-wrap">
                                    <span className="text-one">Event Finished</span>
                                    <span className="text-two">Event Finished</span>
                                </span>
                            </button>
                        </div>
                        
                    </div>
                </div>
            </section>
            {/* <Subscribe2 /> */}
            <VenueSection2 />
            <Footer2/>
            <Scrollbar />
        </Fragment>
    )
};
export default EventSinglePage;
